// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__v6suB","errors":"Errors_errors__3Fwz5"};